export default __webpack_public_path__ + "static/media/stripe-connect.bdd7db4e.png";